import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/frequently_asked_question_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  question_cont: {
    model_name: 'FrequentlyAskedQuestion',
    column_type: 'string',
    column_name: 'question',
  },
}
export const formColumnsConfig = {
  'self': {
    'question': { required: true, disabledUpdate: false },
    'answer': { required: true, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('FrequentlyAskedQuestion', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('FrequentlyAskedQuestion', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
